import React from 'react';
import { useSearchParams } from 'react-router-dom';
import BranchDataPage from './BranchDataPage';

const BranchDataPageWrapper: React.FC = () => {
  const [searchParams] = useSearchParams();
  const customerCode = searchParams.get('customerCode') || '';
  const customerName = searchParams.get('customerName') || '';

  if (!customerCode) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Invalid Parameters</h2>
          <p className="text-gray-600">Customer code is required.</p>
        </div>
      </div>
    );
  }

  // If customerName is not provided, use customerCode as fallback display
  // Also clean up any unwanted characters like carriage returns
  const displayName = customerName 
    ? decodeURIComponent(customerName).replace(/[\r\n]/g, '').trim() 
    : customerCode;

  return (
    <BranchDataPage
      customerCode={customerCode}
      customerName={displayName}
    />
  );
};

export default BranchDataPageWrapper;
